import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
export function Reality() {
  return <section className="py-24 lg:py-40 bg-soft-white relative" data-id="element-216">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-217">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-218">
          <div className="lg:col-span-5" data-id="element-219">
            <FadeIn data-id="element-220">
              <p className="text-[11px] font-semibold tracking-[0.4em] uppercase text-vivid-orange mb-8" data-id="element-221">
                The Reality
              </p>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-medium leading-[1.1] text-deep-azure" data-id="element-222">
                Women founders are{' '}
                <em className="italic font-light text-dark-azure" data-id="element-223">
                  over-networked,
                </em>{' '}
                <em className="italic font-light text-dark-azure" data-id="element-224">
                  over-mentored,
                </em>{' '}
                and{' '}
                <em className="italic font-light text-vivid-orange" data-id="element-225">
                  under-supported.
                </em>
              </h2>
            </FadeIn>
          </div>

          <div className="lg:col-span-6 lg:col-start-7 flex flex-col justify-center" data-id="element-226">
            <FadeIn delay={0.1} data-id="element-227">
              <div className="space-y-6 text-lg text-charcoal-navy/75 leading-relaxed font-light" data-id="element-228">
                <p data-id="element-229">
                  Despite the growth of entrepreneurship programs and founder
                  communities, many women still face barriers accessing
                  measurable business outcomes, operational infrastructure,
                  strategic support, and sustainable pathways to growth.
                </p>
                <p className="text-deep-azure font-normal text-xl font-display italic" data-id="element-230">
                  LeadHERship Equity exists to close that gap.
                </p>
              </div>
            </FadeIn>
          </div>
        </div>

        {/* Editorial stats row */}
        <FadeIn delay={0.3} data-id="element-231">
          <div className="editorial-rule w-full mt-20 mb-16" data-id="element-232"></div>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-233">
          {[{
          number: '225+',
          label: 'Women-Led Businesses Supported'
        }, {
          number: '2025',
          label: 'Ontario Ecosystem Research Launch'
        }, {
          number: '5-Step',
          label: 'Changing Optics Framework™'
        }].map((stat, index) => <StaggerItem key={index} className="text-center md:text-left" data-id="element-234">
              <div className="text-5xl md:text-6xl font-display italic text-vivid-orange mb-3" data-id="element-235">
                {stat.number}
              </div>
              <div className="text-sm font-medium text-deep-azure uppercase tracking-[0.15em]" data-id="element-236">
                {stat.label}
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}